import {loadScript} from "./utils/utils";
import {trackClickEvent} from "./events/clicks-tracker";
import "./utils/ad-params";


var sinonimos = window.sinonimos || {};


window.sinonimos = function() {
    "use strict";
    return {
        init: function() {
            var textbox = document.getElementById('q');
            var windowWidth = window.innerWidth;
            if (windowWidth > 1045 && textbox) {
              textbox.focus();
              textbox.select();
            }

            // Set user image for logged in button
            const loggedInButton = document.querySelector('.btn-header-logged-in');
            if (loggedInButton) {
                const userImage = loggedInButton.getAttribute('data-user-image');
                if (userImage) {
                    loggedInButton.style.setProperty('--user-image', `url(${userImage})`);
                }

                // Handle user menu toggle
                const userMenuWrapper = loggedInButton.closest('.user-menu-wrapper');
                if (userMenuWrapper) {
                    loggedInButton.addEventListener('click', function() {
                        if(window.screen.width > 768) {
                            const isExpanded = this.getAttribute('aria-expanded') === 'true';
                            this.setAttribute('aria-expanded', !isExpanded);
                            userMenuWrapper.classList.toggle('active');
                        }
                    });

                    // Close menu when clicking outside
                    document.addEventListener('click', function(event) {
                        if (!userMenuWrapper.contains(event.target)) {
                            loggedInButton.setAttribute('aria-expanded', 'false');
                            userMenuWrapper.classList.remove('active');
                        }
                    });
                }
            }
        }
    };
}();

(function() {
    window.sinonimos.init();
})();
if(document.getElementById('sinonimos-checkout')) {
    /*import('./donations-checkout').then(module => {
        module.init();
    });*/
    import(
        /* webpackChunkName: "checkout-form-controller" */
        './checkout/checkout-form-controller.ts'
    );
}

if(document.getElementById('copy-pix-code')) {
    import('./copy-pix-code').then(module => {
        module.init();
    });
}
if(document.getElementById('faq')) {
    import('./faq').then(module => {
        module.init();
    });
}
if (document.querySelector(".plan-toggle")) {
  import("./plans").then((module) => {
    module.init();
  });
}

if (document.querySelector(".payment-confirmation-step")) {
  import("./payment-confirmation").then((module) => {
    module.init();
  });
}

if (document.querySelector(".tools-page")) {
  import("./tools-page").then((module) => {
    module.init();
  });
}

import('./events/clicks-tracker').then();
import(/* webpackPrefetch: true, webpackChunkName: "user" */ './user/index').then(() => {
    loadScript('https://accounts.google.com/gsi/client?hl=pt-BR', { async: true, defer: true });
});

const logoutButtonsEl = document.querySelectorAll("[data-logout]");
if (logoutButtonsEl && logoutButtonsEl.length > 0) {
  logoutButtonsEl.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      window.userLogoutHandler();
    });
  });
}

if (document.querySelector(".premium-renew-alert-bar")) {
    document.getElementById("premium-renew-btn")?.addEventListener('click', () => {
        trackClickEvent('banner-renew-PIX');
    });
}
